<template>
<kt-card-title ..._attributes :class="_class">
    <slot></slot>
</kt-card-title>
</template>

<script>
export default {
    props: {
        expanded: {
            type: Boolean,
            default: false,
        },
        event_key: {
            default: function() {
                return randomString(5)
            }
        }
    },
    computed: {
        attributes: function() {
            let _attributes = {
                'data-toggle'  : 'collapse',
                'aria-controls': this.event_key,
                'data-target'  : '#'+this.event_key
            }

            if(this.expanded === true) {
                _attributes['aria-expanded'] = 'true'
            }

            return _attributes
        },
        _class: function() {
            let _class = []

            if(this.expanded === false) {
                _class.push('collapsed')
            }
            
            return _class
        }
    }
}
</script>